(function($){
  $('.mobileMenu').click(function() {

    if($('.mobileMenu').hasClass('.mobileMenu--active')) {
      $('html').bind('touchmove', function(e) { e.preventDefault() });
      $('html').toggleClass('noscroll');
    } else {
      $('html').unbind('touchmove');
      $('html').toggleClass('noscroll');
    }
  });
 })(jQuery);
